var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPintrestLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44517 17.6351C7.77123 21.1637 6.94995 24.5462 4.5143 26.313C3.76348 20.9805 5.61745 16.9766 6.47973 12.7254C5.01014 10.2526 6.65655 5.27877 9.75333 6.50492C13.565 8.01167 6.45283 15.694 11.2268 16.655C16.2121 17.6556 18.2467 8.00655 15.1551 4.86877C10.6899 0.335704 2.15551 4.76242 3.20614 11.252C3.46111 12.8381 5.09983 13.3186 3.86086 15.5083C1.00239 14.8753 0.149077 12.6203 0.259265 9.61452C0.436077 4.69452 4.6783 1.2518 8.93461 0.773892C14.3171 0.170423 19.3691 2.75086 20.0674 7.81308C20.8528 13.5287 17.6381 19.7197 11.8815 19.2739C10.3209 19.1521 9.66748 18.3783 8.44517 17.6351Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintrestLogo);
export default __webpack_public_path__ + "static/media/PintrestLogo.6381194472c17901cfc286f0484965ec.svg";
export { ForwardRef as ReactComponent };